import { Leaf, Shield, Truck, Heart } from "lucide-react"

export default function WhyChoose() {
  const features = [
    {
      icon: <Leaf size={24} className="text-green-600" />,
      title: "Natural Feed",
      description: "Providing fresh, unpreservative milk straight from naturally fed cows.",
    },
    {
      icon: <Shield size={24} className="text-green-600" />,
      title: "No Preservatives",
      description: "100% natural dairy products with no artificial additives.",
    },
    {
      icon: <Truck size={24} className="text-green-600" />,
      title: "Daily Delivery",
      description: "Fresh milk at your door every morning and evening, ensuring maximum freshness.",
    },
    {
      icon: <Heart size={24} className="text-green-600" />,
      title: "Local Farm",
      description: "Sourced from healthy, happy cows in our local community farm.",
    },
  ]

  return (
    <section className="whyChooseSection">
      <div className="whyChooseContainer">
        <h2 className="whyChooseTitle">Why Choose Us</h2>

        <div className="whyChooseGrid">
          {features.map((feature, index) => (
            <div key={index} className="whyChooseItem">
              <div className="whyChooseIcon">{feature.icon}</div>
              <div className="whyChooseContent">
                <h3 className="whyChooseItemTitle">{feature.title}</h3>
                <p className="whyChooseItemText">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}